import { __assign, __spreadArray } from "tslib";
import { feedbackProdConfig, feedbackDebugConfig, } from './feedback-config.constants';
import { getApiHostName } from '../utils/get-api-host-name';
export var debugConfig = __assign(__assign({}, feedbackDebugConfig), { AI_FEEDBACK_PAGE_URL: 'https://local.wix.com:3003', EXPOSURE_SERVICE_BASE_URL: "https://media-feedback-test.".concat(getApiHostName(), "/_api/exposure") });
export function getConfig(debug) {
    if (debug === void 0) { debug = false; }
    var consentPolicyParams = '';
    if (window.consentPolicyManager) {
        consentPolicyParams = Object.entries(window.consentPolicyManager._getConsentPolicyHeader())
            .reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            return __spreadArray(__spreadArray([], acc, true), ["".concat(key, "=").concat(value)], false);
        }, [])
            .join('&');
    }
    if (debug) {
        return __assign(__assign({}, debugConfig), { AI_FEEDBACK_PAGE_URL: "".concat(debugConfig.AI_FEEDBACK_PAGE_URL, "?").concat(consentPolicyParams) });
    }
    var consentPolicy;
    if (window.consentPolicyManager) {
        consentPolicy = window.consentPolicyManager._getConsentPolicyHeader();
    }
    // prod config
    return __assign(__assign({}, feedbackProdConfig), { AI_FEEDBACK_PAGE_URL: "https://manage.".concat(getApiHostName(), "/user-feedback-client").concat(consentPolicy ? "?".concat(consentPolicyParams) : ''), EXPOSURE_SERVICE_BASE_URL: "https://media-feedback.".concat(getApiHostName(), "/_api/exposure") });
}
//# sourceMappingURL=config.constants.js.map